import React, { useEffect, useState } from "react";
import { Container, Title, Text } from "@mantine/core";
import Login from "../components/Login";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";

export default function LoginPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      navigate("/");
    }
  }, []);

  const handleLogin = async (event, email, password) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/login`, {
        email,
        password,
      });
      localStorage.setItem("accessToken", response.data.data.token);
      localStorage.setItem("userId", response.data.data.id);
      window.location.reload();
    } catch (error) {
      setError("Invalid email or password");
    }
  };

  return (
    <>
      <div className="homeText">
        <Title className="title" align="center">
          Cardify
        </Title>

        <Text align="center">A simple flashcard app to help you study</Text>
      </div>

      <Container
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh", height: "500px" }}
      >
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Login handleLogin={handleLogin} error={error} />
        </div>
      </Container>
    </>
  );
}
